import React from "react";
import leadCapture from "../../assets/images/lead-management/lead-capture.png";
import onlineChannels from "../../assets/images/lead-management/online-channels.png";
import streamLineSalesPipeline from "../../assets/images/lead-management/streamline-sales-pipeline.png";

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/40 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-space-y-24 lg:tw-space-y-36">

        {/* Section 1: Lead Capture */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          {/* Left: Text */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Lead Capture
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-8">
              BeyondLeadz makes it easy for businesses to connect with potential customers by capturing vital information right at the source. With direct lead capture, you can seamlessly gather important details like names, emails, phone numbers, and company info—all in real time. No more missed opportunities, just instant access to the leads that matter, so you can engage the right people at the right moment.
            </p>

            <ul className="tw-space-y-6 tw-p-0 tw-m-0">
              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Effortless lead collection
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Instantly capture valuable customer details from various sources.
                  </p>
                </div>
              </li>
              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Timely engagement
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Get the info you need to start building relationships immediately.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          {/* Right: Image */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-30 tw-blur-2xl" />
              <img
                src={leadCapture}
                alt="Lead Capture"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Section 2: Online Channels */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          {/* Left: Image (Order-last on mobile, first on desktop) */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center tw-order-last lg:tw-order-first">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-30 tw-blur-2xl" />
              <img
                src={onlineChannels}
                alt="Online Channels"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>
          {/* Right: Text */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Online Channels
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-8">
              BeyondLeadz lead alerts notify your sales and marketing teams instantly when new leads are captured, enabling fast follow-ups for higher conversions. Ideal for businesses with high lead volumes, these alerts can be sent via email, SMS, WhatsApp, or other channels. They include key details like the lead’s name, email, and phone number, ensuring quick and effective responses.
            </p>

            <ul className="tw-space-y-6 tw-p-0 tw-m-0">
              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Instant notifications
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Stay ahead by responding to leads as soon as they come in.
                  </p>
                </div>
              </li>
              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Multi-channel delivery
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Receive alerts through the channels most convenient for your team.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Section 3: Streamline Sales Pipeline */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          {/* Left: Text */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Streamline your sales pipeline
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-8">
              Easily visualize every stage of your sales process to ensure nothing slips through the cracks. Prioritize key opportunities and stay organized by moving leads through each phase, closing deals faster and improving efficiency. Kanban makes lead management simple and effective, driving better results.
            </p>

            <ul className="tw-space-y-6 tw-p-0 tw-m-0">
              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Clear Insights
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Easily identify and prioritize high-potential leads.
                  </p>
                </div>
              </li>
              <li className="tw-flex tw-gap-4">
                <div className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-indigo-50 tw-flex tw-items-center tw-justify-center tw-text-[#5D44FF] tw-font-bold tw-text-xs tw-flex-shrink-0 tw-mt-1">
                  ✓
                </div>
                <div>
                  <h4 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-1">
                    Efficient Workflow
                  </h4>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    Seamlessly manage leads and close deals faster.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          {/* Right: Image */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-30 tw-blur-2xl" />
              <img
                src={streamLineSalesPipeline}
                alt="Streamline your sales pipeline"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
